import { asiakasSettings_get } from "../asiakas/AsiakasSettingsFunctions";
import { tuote_fetch } from "../laskuTuote/TuoteFunctions";
import { tarjous_fetchById } from "../tarjous/TarjousFunctions";
import { keikkaLaskuRivi_deleteAll, keikkaLaskuRivi_saveToDB } from "./KeikkaLaskuRiviFunctions";
import keikkaEval from "./keikkaEval";
import keikkaLaskuRiviClass from "./keikkaLaskuRiviClass";

export async function refreshKustannusPaikat(keikkaLasku, keikkaData, toimitus, token) {
  const returnMessage = { changeCount: 0, messages: [] };
  for (let i = 0; i < keikkaLasku.keikkaLaskuRivit.length; i++) {
    const rivi = keikkaLasku.keikkaLaskuRivit[i];
    if (rivi.isLaskutettu) {
      returnMessage.messages.push("rivi jo laskutettu, ei laiteta kustannuspaikkoja");
      continue;
    }
    const _tuoteResult = await tuote_fetch(rivi.tuoteId, token);
    if (!_tuoteResult.success) {
      returnMessage.messages.push("Tuotteen haku epäonnistui, tuoteId:" + rivi.tuoteId);
      console.log("Error", _tuoteResult.message, _tuoteResult.error);
      continue;
    }
    const _tuote = _tuoteResult.data;
    const _kustannusPaikkaEval = _tuote.kustannusPaikkaEval;
    const _kustannusPaikkaEvalResult = keikkaEval(
      _kustannusPaikkaEval,
      keikkaData,
      keikkaLasku,
      toimitus
    );
    if (_kustannusPaikkaEvalResult.success) {
      const _kustannusPaikka = _kustannusPaikkaEvalResult.result.string;
      if (rivi.kustannusPaikka != _kustannusPaikka) {
        rivi.kustannusPaikka = _kustannusPaikka;
        returnMessage.messages.push("Kustannuspaikka päivitetty");
        returnMessage.changeCount++;
        returnMessage.changeCount++;
        await keikkaLaskuRivi_saveToDB(rivi, token);
      } else {
        returnMessage.messages.push("Ei muutosta kustannuspaikassa");
      }
    } else {
      returnMessage.messages.push("kustannuspaikan kaava virhe");
      console.log("kustannuspaikan kaava virhe");
    }
  }
  return keikkaLasku;
}

export function keikkaLasku_countActiveRows(keikkaLasku) {
  let count = 0;
  for (let i = 0; i < keikkaLasku.keikkaLaskuRivit.length; i++) {
    const rivi = keikkaLasku.keikkaLaskuRivit[i];
    if (rivi.isLaskutettu) continue;
    if (rivi.määrä == 0) continue;

    count++;
  }
  return count;
}

export async function keikkaLasku_createRivitFromTarjoukset(
  tarjousList,
  keikkaData,
  keikkaLasku,
  toimitus,
  user,
  token,
  userAsiakas
) {
  await keikkaLaskuRivi_deleteAll(keikkaLasku, token);
  const promises = [];
  for (let i = 0; i < tarjousList.length; i++) {
    let _response = await tarjous_fetchById(user, tarjousList[i].tarjousId, token);
    const tarjous = _response.data;
    const rivitCount = tarjous.tarjousRivit.length;
    for (let j = 0; j < rivitCount; j++) {
      const tarjousRivi = tarjous.tarjousRivit[j];
      const keikkaLaskuRivi = new keikkaLaskuRiviClass(
        keikkaData.keikkaId,
        keikkaLasku.keikkaLaskuId
      );
      keikkaLaskuRivi.tuoteIdKaava = tarjousRivi.tuoteIdEval || tarjousRivi.tuoteId;
      keikkaLaskuRivi.tuoteId = keikkaEval(
        tarjousRivi.tuoteIdEval || tarjousRivi.tuoteId,
        keikkaData,
        keikkaLasku,
        toimitus
      ).result.num;

      let tuote = null;
      if (keikkaLaskuRivi.tuoteId > 0) {
        const _result = await tuote_fetch(keikkaLaskuRivi.tuoteId, token);
        if (_result.success) tuote = _result.data;
      }
      keikkaLaskuRivi.alv =
        tuote?.alv || (await asiakasSettings_get(userAsiakas, userAsiakas.asiakasId, 10));
      keikkaLaskuRivi.ehtoKaava = tarjousRivi.evalCriteria;
      keikkaLaskuRivi.ehtoTäyttyy = keikkaEval(
        tarjousRivi.evalCriteria,
        keikkaData,
        keikkaLasku,
        toimitus
      ).result.bool;
      keikkaLaskuRivi.hintaKaava = tarjousRivi.hintaEval || tarjousRivi.hinta;
      keikkaLaskuRivi.hinta = keikkaEval(
        keikkaLaskuRivi.hintaKaava,
        keikkaData,
        keikkaLasku,
        toimitus
      ).result.num;
      keikkaLaskuRivi.kustannusPaikka = keikkaEval(
        tuote.kustannusPaikkaEval,
        keikkaData,
        keikkaLasku,
        toimitus
      ).result.string;
      keikkaLaskuRivi.laskuttajaAsiakasId = keikkaLasku.laskuttajaAsiakasId;
      keikkaLaskuRivi.maksajaAsiakasId = keikkaLasku.maksajaAsiakasId;
      keikkaLaskuRivi.memo = "";
      keikkaLaskuRivi.määräKaava = tarjousRivi.maaraEval;
      keikkaLaskuRivi.määrä = keikkaEval(
        keikkaLaskuRivi.määräKaava,
        keikkaData,
        keikkaLasku,
        toimitus
      ).result.num;
      keikkaLaskuRivi.riviSeliteKaava = tarjousRivi.otsikko;
      keikkaLaskuRivi.riviSelite = tarjousRivi.otsikko;
      keikkaLaskuRivi.riviSelite2Kaava = tarjousRivi.laskuRiviTxtEval;
      keikkaLaskuRivi.riviSelite2 = keikkaEval(
        tarjousRivi.laskuRiviTxtEval,
        keikkaData,
        keikkaLasku,
        toimitus
      ).result.string;
      keikkaLaskuRivi.sortNum = tuote.orderNum || -1;
      keikkaLaskuRivi.yksikkö = tuote.yksikkö || "";
      promises.push(keikkaLaskuRivi_saveToDB(keikkaLaskuRivi, token));
      //await keikkaLaskuRivi_saveToDB(keikkaLaskuRivi, token);
    }
  }
  await Promise.all(promises);
}

export async function keikkaLasku_getAllKeikkaLaskutForKeikka(
  keikkaId,
  laskuttajaAsiakasId,
  token
) {
  const fullUrl =
    import.meta.env.VITE_SERVER_URL +
    "/api/keikka/laskutus/keikkaLasku/getAllKeikkaLaskutForKeikka";
  const data = { keikkaId: keikkaId, laskuttajaAsiakasId: laskuttajaAsiakasId };
  const response = await fetch(fullUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(data),
  });
  const r = await response.json();
  return r;
}
